import {
    Datagrid,
    // Filter,
    FilterButton,
    List,
    TextField,
    TextInput,
    TopToolbar
} from 'react-admin';
import { useClientContext } from "contexts/client";
import ExportButton from 'custom_components/CSVExportButton';

const CustomerFilter = [
        <TextInput source="id" />,        
        <TextInput source="store_name" />,
        <TextInput source="store_address" />,
        <TextInput source="city" />,
        <TextInput source="state" />,
        <TextInput source="zip" /> 
];

const ListActions = () => {

    const {state} = useClientContext();
    return (
        <TopToolbar>
            <FilterButton />
            <ExportButton resource={`${state.client.resourcePrefix}_nrs_stores`}/>
        </TopToolbar>
    )
};

export const NRSList = props => (
    <List 
        {...props}
        filters={CustomerFilter} 
        bulkActionButtons={false}
        actions={<ListActions />}
        >
        <Datagrid rowClick="edit">
            <TextField label="NRS Store ID" source="id" />            
            <TextField source="store_name" />
            <TextField source="store_address" />
            
            <TextField source="city" />
            <TextField source="state" />
            <TextField source="zip" /> 

        </Datagrid>
    </List>
);